export const addTokenToTronLink = (data) => {
    console.log(data)
    const tronWeb = window.tronWeb;
    const params = {
        type: data.type,
        options: {
            address: data.address,
            symbol: data.name || '',
            decimals: data.decimals,
            image: data.icon_url || '',
        },
    };
    // console.log('params', params);
    // console.log(JSON.stringify(params))
    tronWeb.request({
        method: 'wallet_watchAsset',
        params: params,
    })
}